<template>
  <a-upload
    :custom-request="customRequest"
    @change="handleChange"
    v-model:file-list="fileList"
    :remove="removeFile"
    :multiple="true"
  >
    <a-button :disabled="props.disabled">
      <upload-outlined></upload-outlined>
      上传文件
    </a-button>
  </a-upload>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { UploadOutlined } from "@ant-design/icons-vue";
import { uploadProjectImage, deleteFile } from "@/request/view/project";
import { Toast } from "@/utils";

export default defineComponent({
  components: { UploadOutlined },
  props: {
    echoFile: String,
    disabled: Boolean,
  },
  setup(props, context) {
    const fileList = ref([]);

    const handleChange = ({ file, fileList }) => {
      if (file.status !== "uploading") {
        const findIndex = fileList.findIndex((f) => f.uid === file.uid);
        if (findIndex !== -1) {
          fileList.splice(findIndex, 1);
        }
      }

      console.log(file, fileList);
    };

    const setUploadFileUrl = () => {
      context.emit("setUploadFileUrl", fileList);
    };

    const removeFile = (file) => {
      if (file.url) {
        deleteFile([file.url])
          .then((res) => {
            console.log(res);
            setUploadFileUrl();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };

    const customRequest = (file) => {
      const formData = new FormData();
      formData.append("files", file.file);
      uploadProjectImage(formData)
        .then((res) => {
          const findIndex = fileList.value.findIndex(
            (f) => f.uid === file.file.uid
          );
          fileList.value[findIndex].status = "done";
          fileList.value[findIndex].url = res.data[0];
          setUploadFileUrl();
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const getSuffixName = (str) => {
      const lastSlash = str.split("").findLastIndex((item) => item === "/");
      if (lastSlash !== -1) {
        return str.slice(lastSlash + 1);
      }
      return "";
    };

    const setEchoFile = (file) => {
      file.split(",").forEach((file) => {
        fileList.value.push({
          status: "done",
          name: getSuffixName(file),
          url: file,
        });
      });
    };

    const resetFileList = () => {
      fileList.value.length = 0;
    };
    // watch(
    //   () => props.echoFile,
    //   (val) => {
    //     fileList.value.length = 0;
    //     if (val) {
    //       fileList.value.push({
    //         status: "done",
    //         name: getSuffixName(val),
    //         url: val,
    //       });
    //     }
    //   },
    //   {
    //     immediate: true,
    //     deep: true,
    //   }
    // );

    return {
      props,
      fileList,
      setEchoFile,
      resetFileList,
      removeFile,
      setUploadFileUrl,
      customRequest,
      handleChange,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
